module.exports = __webpack_public_path__ + "img/vartext3.378ddb47.svg";